/** @format */

import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { PageContainer, StepperKeeper, Icons } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import services from '../services/Services';
import { CheckCollateral, CheckDoc, CreateSignature, Filing, IssuingWarranty } from './components';
import useCustomHook from './hooks';
import { constBreadCrumbsTitle } from 'utility';

const DetailWarranty = () => {
  const defaultValues = {
    name: null, // [String]
  };
  const methods = useForm({ defaultValues });
  const { handleSubmit, formState: { errors } } = methods;
  const {
    status,
    WarrantyId,
    activeStep, setActiveStep,
    isLoading, setIsLoading,
    copyStep, setCopyStep,
    result, setResult,
    warrantyType, setWarrantyType,
    navigate,
    stepperTitles,
    isError, setIsError,
    pageTitle,
  } = useCustomHook();

  const panels = {
    'PARTICIPATION_TENDERS': [
      <CheckDoc result={result} />,
      <CheckCollateral result={result} />,
      <CreateSignature result={result} />,
      <Filing result={result} />,
      <IssuingWarranty result={result} />,
    ],
    'CASH_PARTICIPATION_TENDERS': [
      <CheckDoc result={result} />,
      <CreateSignature result={result} />,
      <Filing result={result} />,
      <IssuingWarranty result={result} />,
    ]
  };

  useEffect(() => {
    if (WarrantyId) {
      getWarranty(WarrantyId?.id);
    }
  }, [WarrantyId]);
  const params = {
    entityId: WarrantyId?.id,
  };
  const toCamelCase = (str) => {
    return str.replace(/[-\s](\w)/g, (match, letter) => letter.toUpperCase());
  };
  const mapCamelCase = (obj) => {
    let result = {};
    for (let key in obj) {
      let camelKey = toCamelCase(key);
      result[camelKey] = obj[key];
      if (typeof obj[key] === 'object') {
        result[camelKey] = mapCamelCase(obj[key]);
      }
    }
    return result;
  };

  const getStep = (warrantyType, warrntyStep) => {
    const w = status[warrantyType];
    return w[warrntyStep];
  }
  // -- API REQUESTS --//
  async function getWarranty() {
    setIsLoading(true);
    try {
      let res = null;
      res = await services.getRequestList(params);
      let mappedData = mapCamelCase(res?.result);
      let result = Object.values(mappedData);
      const step = result[0]?.source?.warrantyStep;
      const type = result[0]?.source?.warrantyType;
      setWarrantyType(type);
      setCopyStep(getStep(type, step));
      setActiveStep(getStep(type, step));
      setTimeout(() => {
        setResult(result[0]);
        setIsLoading(false);
      }, 10);
    } catch (e) {
      setIsError(true);
      setIsLoading(false);
    }
  }


  const hint = 'در این بخش می توانید جزئیات درخواست‌های خود را مشاهده کنید.';

  return (
    <PageContainer
      description={hint}
      title={pageTitle[warrantyType]}
      breadcrumbs={constBreadCrumbsTitle.WARRANTY_REQUEST_DETAILS}
      loading={isLoading}
      meta={
        <Button
          color="primary"
          variant="outlined"
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
          onClick={() => navigate('/Warranty/RequestList')}
        >
          بازگشت
        </Button>
      }
    >

      {
        !isError && result &&
        <FormProvider {...methods}>
          <form onSubmit={(e) => e?.preventDefault()} noValidate autoComplete="off">
            <StepperKeeper
              titles={stepperTitles[warrantyType]}
              checkDeactive={'true'}
              alternativeLabel
              onStepChanged={(e) => {
                setActiveStep(e);
              }}
              forceSelectedTabIndex={activeStep}
              stepsToHideNext={[copyStep]}
              panels={panels[warrantyType]}
            />
          </form>
        </FormProvider>
      }
    </PageContainer>
  );
};

export default DetailWarranty;
